import React from "react"
import Home from "./home/home";

export default () => (
    <div>
        <Home />
    </div>
)